import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-roll-uninti-form',
  templateUrl: './time-roll-uninti-form.component.html',
  styleUrls: ['./time-roll-uninti-form.component.css']
})
export class TimeRollUnintiFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/time-roll-unintigrated/time-roll-uninti-form/time-roll-uninti-form.component.ts